<template>
  <Pill
    link=""
    :text="text"
    :data-event-tracking="dataEventTracking"
    @click-trigger="handleClick"
  />
</template>

<script>
import Pill from './Pill.vue';
import { Browser } from '@capacitor/browser';
import { FirebaseAnalytics } from '@/utils/firebase-analytics-wrapper';

export default {
  name: 'PillBrowserLink',
  components: { Pill },
  props: {
    text: { type: String, required: true },
    url: { type: String, required: true },
    firebaseEventName: { type: String, required: true },
    dataEventTracking: { type: String, default: '' },
    windowTarget: { type: String, default: '' },
  },
  methods: {
    handleClick() {
      FirebaseAnalytics.logEvent({
        name: 'click_button',
        params: { button_name: this.firebaseEventName, page: 'home' },
      });
      const options = { url: this.url };
      if (this.windowTarget) options.windowName = this.windowTarget;
      Browser.open(options);
    },
  },
};
</script>
